import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import _debounce from 'lodash/debounce';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
export default function useIntersectionObserver(targetRef) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$root = _ref.root,
    root = _ref$root === void 0 ? null : _ref$root,
    _ref$rootMargin = _ref.rootMargin,
    rootMargin = _ref$rootMargin === void 0 ? '100px' : _ref$rootMargin,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0.05 : _ref$threshold,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 100 : _ref$debounce,
    _ref$defaultActive = _ref.defaultActive,
    defaultActive = _ref$defaultActive === void 0 ? true : _ref$defaultActive;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inViewport = _useState2[0],
    setInViewport = _useState2[1];
  var _useState3 = useState(defaultActive),
    _useState4 = _slicedToArray(_useState3, 2),
    active = _useState4[0],
    setActive = _useState4[1];
  var observer = useRef(null);
  function getElement(ref) {
    if (_isEmpty(ref)) {
      return null;
    }
    return _get(ref, 'current', ref);
  }
  var handleIntersection = _debounce(function (entries) {
    var isInViewport = entries.some(function (entry) {
      return entry.isIntersecting;
    });
    setInViewport(isInViewport);
  }, debounce);
  function disconnect() {
    var _observer$current;
    var element = getElement(targetRef);
    if (element && observer.current) {
      observer.current.unobserve(element);
    }
    (_observer$current = observer.current) === null || _observer$current === void 0 ? void 0 : _observer$current.disconnect();
    observer.current = null;
    setActive(false);
  }
  useEffect(function () {
    if (!active) {
      return disconnect;
    }
    var element = getElement(targetRef);
    if (!element) {
      return disconnect;
    }
    if (!observer.current) {
      observer.current = new IntersectionObserver(handleIntersection, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
      });
    }
    if (element) {
      observer.current.observe(element);
    }
    return disconnect;
  }, [getElement(targetRef), root, rootMargin, threshold]);
  return {
    inViewport: inViewport,
    disconnect: disconnect
  };
}